import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

import FormField from "../forms/FormField";
import SelectInput from "../forms/SelectInput";

const timeOptionKeys = [
  "today",
  "last_hour",
  "since_07",
  "since_08",
  "since_09",
  "since_10",
  "since_11",
  "since_12",
  "since_13",
  "since_14",
  "since_15",
  "since_16",
  "since_17",
  "since_18",
  "since_19",
  "since_20",
  "yesterday",
  "this_week",
  "this_month",
  "this_year",
  "trailing_7_days",
  "trailing_8_days",
  "trailing_4_weeks",
  "trailing_5_weeks",
  "trailing_8_weeks",
  "trailing_12_months",
  "all_time",
];

function calculateStartEnd(optionKey) {
  const now = DateTime.now().setZone("Europe/Istanbul");
  let start;

  switch (optionKey) {
    case "today":
      start = now.set({ hour: 6, minute: 0, second: 0, millisecond: 0 });
      break;
    case "last_hour":
      start = now.minus({ hours: 1 });
      break;
    case "yesterday":
      start = now
        .minus({ days: 1 })
        .set({ hour: 6, minute: 0, second: 0, millisecond: 0 });
      break;
    case "this_week":
      start = now.startOf("week").plus({ seconds: 1 });
      break;
    case "this_month":
      start = now.startOf("month").plus({ seconds: 1 });
      break;
    case "this_year":
      start = now.startOf("year").plus({ seconds: 1 });
      break;
    case "trailing_7_days":
      start = now.minus({ days: 7 });
      break;
    case "trailing_8_days":
      start = now.minus({ days: 8 });
      break;
    case "trailing_4_weeks":
      start = now.minus({ days: 30 });
      break;
    case "trailing_5_weeks":
      start = now.minus({ days: 35 });
      break;
    case "trailing_8_weeks":
      start = now.minus({ days: 60 });
      break;
    case "trailing_12_months":
      start = now.minus({ months: 12 });
      break;
    case "all_time":
      start = DateTime.fromObject(
        {
          year: 2025,
          month: 1,
          day: 1,
          hour: 0,
          minute: 1,
          second: 0,
          millisecond: 0,
        },
        { zone: "Europe/Istanbul" }
      );
      break;      
    default: {
      const hour = parseInt(optionKey.split("_")[1], 10);
      if (!isNaN(hour)) {
        start = now.set({ hour, minute: 0, second: 0, millisecond: 0 });
      } else {
        start = now.minus({ hours: 1 });
      }
    }
  }

  const end = now.plus({ minutes: 1 });

  return {
    start: start.toFormat("yyyy-MM-dd'T'HH:mm"),
    end: end.toFormat("yyyy-MM-dd'T'HH:mm"),
  };
}

export default function TimeRangeSelector({ onRangeChange }) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState("today");

  useEffect(() => {
    const { start, end } = calculateStartEnd(selected);
    onRangeChange({ start, end });
  }, [selected, onRangeChange]);

  return (
    <FormField label={t("time_dropdown.label")}>
      <SelectInput
        value={selected}
        onChange={(e) => setSelected(e.target.value)}
      >
        {timeOptionKeys.map((key) => (
          <option key={key} value={key}>
            {t(`time_dropdown.values.${key}`)}
          </option>
        ))}
      </SelectInput>
    </FormField>
  );
}